import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { FluentDialog2 } from "../../../../../../components/FluentUI/Fluent-Dialog2";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { GetIconForField, radioOptions } from "../form-design/form-design-util";
import { FluentInput } from "../../../../../../components/FluentUI/Fluent-Input";
import { FluentInputArea } from "../../../../../../components/FluentUI/Fluent-InputArea";
import { FluentCheckbox } from "../../../../../../components/FluentUI/Fluent-Checkbox";
import { FluentRadio } from "../../../../../../components/FluentUI/Fluent-Radio";
import { FluentButton } from "../../../../../../components/FluentUI/Fluent-Button";
import { DeleteDialog } from "./delete-dialog";

export const CreateEditField = ({
  field,
  open,
  OnCancel,
  SaveField,
  DeleteField,
}) => {
  const [currentField, setCurrentField] = useState({});
  const [dialog2, setDialog2] = useState(false);
  const ref = useRef(0);

  useEffect(() => {
    setCurrentField(field);
    ref.current++;
  }, [field]);

  const OnSaveField = () => {
    SaveField(currentField);
  };

  const OnDeleteField = () => {
    DeleteField(currentField);
  };

  return (
    <>
      <FluentDialog2 open={open} key={ref.current}>
        <div className="task-type-dialog-title">
          <p>Edit Form Field</p>
          <p onClick={OnCancel}>
            <FluentUiIcon name={"DismissRegular"} color={"#212121"} size={20} />
          </p>
        </div>
        <div className="task-type-dialog-content">
          <div className="task-type-create-edit-field-dialog">
            <div className="task-type-create-edit-field-dialog-type">
              <div className="task-type-create-edit-field-dialog-type-icon">
                <FluentUiIcon
                  name={GetIconForField(currentField?.FieldType)}
                  color={"#616161"}
                  size={20}
                />
              </div>
              <div className="task-type-create-edit-field-dialog-type-text">
                <div className="task-type-create-edit-field-dialog-type-text-head">
                  {currentField?.FieldType}
                </div>
                <div className="task-type-create-edit-field-dialog-type-text-foot">
                  {currentField?.Description}
                </div>
              </div>
            </div>
            <div className="task-type-create-edit-field-dialog-above-border">
              <FluentInput
                placeholder={"Enter field API name"}
                label={"API name"}
                disabled={true}
                defaultValue={currentField?.APIName}
              ></FluentInput>
              <FluentInputArea
                label={"Field description"}
                defaultValue={currentField?.Description}
                disabled={true}
                placeholder={"Enter field description"}
              ></FluentInputArea>
              <FluentInput
                placeholder={"Enter field label"}
                label={"Field label"}
                disabled={true}
                defaultValue={currentField?.Label}
              ></FluentInput>
              <FluentInput
                placeholder={"Enter field local label"}
                label={"Local label"}
                defaultValue={currentField?.LocalLabel}
                onBlur={(e) => {
                  const { value } = e.target;
                  setCurrentField((prev) => ({
                    ...prev,
                    LocalLabel: value,
                  }));
                }}
              ></FluentInput>
              <FluentCheckbox
                label={"Mandatory Field"}
                checked={currentField?.IsRequired}
                disabled={field?.FieldType === "Table"}
                onChange={(e) => {
                  const { checked } = e.target;
                  setCurrentField((prev) => ({
                    ...prev,
                    IsRequired: checked,
                  }));
                }}
              ></FluentCheckbox>
            </div>
            <div className="task-type-create-edit-field-dialog-below-border">
              <FluentRadio
                label="Is this Field editable?"
                value={currentField?.IsDisabled}
                options={radioOptions}
                onChange={(e) => {
                  const { value } = e.target;
                  setCurrentField((prev) => ({
                    ...prev,
                    IsDisabled: value === "true",
                  }));
                }}
              ></FluentRadio>
            </div>
          </div>
        </div>
        <div className="task-type-dialog-footer">
          <FluentButton
            onClick={() => setDialog2(true)}
            text={"Remove this Field"}
            backgroundColor={"#0F6CBD"}
          />
        </div>
        <div className="task-type-dialog-footer">
          <FluentButton
            onClick={OnCancel}
            text={"Cancel"}
            backgroundColor={"#0F6CBD"}
          />
          <FluentButton
            onClick={OnSaveField}
            appearance="primary"
            text="Save"
            backgroundColor={"#0F6CBD"}
          />
        </div>
      </FluentDialog2>

      {dialog2 && (
        <DeleteDialog
          identifier="Field"
          open={dialog2}
          OnCancel={() => setDialog2(false)}
          OnDelete={OnDeleteField}
        ></DeleteDialog>
      )}
    </>
  );
};

CreateEditField.propTypes = {
  field: PropTypes.object,
  open: PropTypes.bool.isRequired,
  OnCancel: PropTypes.func.isRequired,
  SaveField: PropTypes.func.isRequired,
  DeleteField: PropTypes.func.isRequired,
};
